export default __webpack_public_path__ + "static/media/logout.59b8c7ce.svg";